import * as yup from 'yup';

export const userEditValidationSchema = {
  userName: yup
    .string()
    .min(2, 'User Name is too short!')
    .max(100, 'User Name is too long!')
    .required('User Name is required!'),
  subscribeEmailId: yup
    .string()
    .email('Invalid email format')
    .required('Email is required!')
};
